
import React from 'react';

import IsknActualInfoPageState from './IsknActualInfoPage.state';

const IsknActualInfoPage = (props) => {

    return (
        <IsknActualInfoPageState
            match={props.match}
        />
    )
}

export default IsknActualInfoPage;
